import Mutations from '../../odata/mutations';

export default { ...new Mutations('deliveryDate'), ...new Mutations('deliveryDates') };
